import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export default function useAlertBanner() {
  const [open, setOpen] = useState(false)
  const [t] = useTranslation()
  const [alertBannerProps, setAlertBannerProps] = useState({
    type: 'error',
    message: '',
    dismissText: t('common-ui:dismiss.action', 'Dismiss'),
  })
  return { ...alertBannerProps, setAlertBannerProps, open, setOpen }
}
